module.exports = __webpack_public_path__ + "img/ch18_04_误差归零.2fbf06a6.png";